import React from "react";
import Icons from "../../../../config/images";
import "./story.css";

const ImageSection = () => (
  <div className="image-section">
    <img src={Icons.phoneSimulator} alt="Software Development" />
  </div>
);

const CompanyInfo = () => (
  <div className="company-info">
    <h3 className="company-info-title">Our Story</h3>
    <p className="company-info-sub-title-style">
      Our story began with a simple vision: to empower businesses with
      innovative digital solutions that truly make a difference. Since day one,
      we’ve dedicated ourselves to crafting exceptional designs, developing
      cutting-edge applications, and building websites that set new standards.
      Over the years, we’ve collaborated with clients across industries, helping
      them achieve their goals and elevate their brands
    </p>
    <h3 className="company-info-expertise-title">Our Mission & Vision</h3>
    <ul className="company-info-expertise-details-style">
      <li className="company-info-expertise-seperate-details-style">
        <p className="company-info-sub-title-black-text-style">
          Mission statement:
        </p>
        <p className="company-info-sub-title-style">
          {" "}
          To transform ideas into reality by delivering intuitive designs, robust development, and innovative solutions that leave a lasting impact.
        </p>
      </li>
      <li className="company-info-expertise-seperate-details-style">
        <p className="company-info-sub-title-black-text-style">
        Vision Statement:
        </p>
        <p className="company-info-sub-title-style">
          {" "}
          To be the trusted partner for businesses worldwide, empowering them to thrive in the digital era through exceptional creativity and technology..
        </p>
      </li>
    </ul>
  </div>
);

const StorySection = () => {
  return (
    <>
      <CompanyInfo />
      <ImageSection />
    </>
  );
};

export default StorySection;
